module.exports = __webpack_public_path__ + "static/media/BB.c9ab9ff9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BB.svg
// module id = 199
// module chunks = 0